import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LogoInterface, LogoModel } from '../../../@core/models/site-data.model';
import * as Sentry from "@sentry/browser";
import { DataService } from 'src/app/@core/services/data.service';


@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MaterialLogoComponent implements OnInit {

  @Input() logoImg: LogoModel;
  @Input() grayedOut: boolean = true;
  title: string;
  titleSize: string;
  backgroundColor: string;
  titleColor: string;
  textColor: string;
  fontWeight: string;
  subTitleColor: string;
  subTitle: string;
  textAlign: string;
  activatePadding: boolean = false;
  textSize: string;
  titleInputValue: string;
  subTitleInputValue: string;
  subscription: Subscription;
  data: LogoInterface;
  position: number = 0;
  moduleInfo: string;
  allElementAnimation: string;
  textAnimation: string;
  imageAnimation: string;
  loading: boolean = true;

  constructor(private dataService: DataService) { }

  ngOnInit() {
    if (this.data.animation) {
      this.allElementAnimation = this.data.animation.allElement != '' ? this.data.animation.allElement : undefined;
      this.textAnimation = this.data.animation.text != '' ? this.data.animation.text : undefined;
      this.imageAnimation = this.data.animation.image != '' ? this.data.animation.image : undefined;

    }
    this.loading = false;
    Sentry.configureScope(function (scope) {
      scope.setTag("component", "LogoComponent");
    });
    this.moduleInfo = JSON.stringify({ position: this.position, new: false });
    this.logoImg = this.data.link;
    this.title = this.data.title;
    this.textAlign = this.data.textAlign;
    this.subTitle = this.data.subTitle;
    this.textSize = this.data.textSize;
    this.fontWeight = this.data.fontWeight ? this.data.fontWeight : '700';
    this.subTitleColor = this.data.subTitleColor;
    this.backgroundColor = this.data.backgroundColor ? this.data.backgroundColor : '';
    this.titleInputValue = this.data.title;
    this.titleSize = this.data.titleSize ? this.data.titleSize : '';
    this.subTitleInputValue = this.data.subTitle ? this.data.subTitle : '';
    this.titleColor = this.data.titleColor ? this.data.titleColor : this.data.textColor;
    this.textColor = this.data.textColor ? this.data.textColor : this.dataService.getDefaultColor(this.backgroundColor);
  }

}
